// extracted by extract-css-chunks-webpack-plugin
module.exports = {"modal-text":"styles__modal-text___-gl5I","modalText":"styles__modal-text___-gl5I"};
    if(module.hot) {
      // 1769029284463
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  